import React, { useRef } from 'react';
import { toast } from 'react-toastify';
import IconMan from '../../images/common/icon_man11.png';
import IconMan2x from '../../images/common/icon_man11@2x.png';

type PhotosProps = {
  photoPreview: string;
  photoStatus: string;
  photoComments: string;
  canUpload: boolean;
  onPhotoChange: (file: File, preview: string) => void;
  onPhotoRemove: () => void;
};

const Photos = ({ photoPreview, photoStatus, photoComments, canUpload, onPhotoChange, onPhotoRemove }: PhotosProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (!canUpload) {
      toast.error("写真の登録には性病検査または精液検査の登録が必要です");
      return;
    }
    inputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      onPhotoChange(file, reader.result as string);
    };
    reader.readAsDataURL(file);

    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  return (
    <>
      <h3 className="sub_title">プロフィール写真</h3>
      <div className="form">
        <dl className="graf_list">
          <dt>写真</dt>
          <dd>
            <div className={ `thumb${ !photoPreview ? ' no-photo' : '' }` }>
              { photoPreview && (
                <button type="button" onClick={ onPhotoRemove }>✕</button>
              ) }
              <img
                src={ photoPreview || IconMan }
                srcSet={ photoPreview ? undefined : `${ IconMan } 1x, ${ IconMan2x } 2x` }
                alt=""
                style={ { cursor: 'pointer' } }
                onClick={ handleClick }
              />
              { !photoPreview && (
                <div className="photo-overlay" onClick={ handleClick }>
                  <span>+</span>
                </div>
              ) }
            </div>
            <input
              type="file"
              accept="image/*"
              ref={ inputRef }
              onChange={ handleFileChange }
              style={ { display: 'none' } }
            />
          </dd>
        </dl>
        { photoStatus === 'REMANDED' && photoComments && (
          <div className="border_box pink">
            <span className="txt_pink alert_msg">
              現在写真は公開されておりません。以下をご対応の上で再度保存してください。：<br />
              { photoComments.split('\n').map((line, idx) => (
                <React.Fragment key={ idx }>
                  { line }<br />
                </React.Fragment>
              )) }
            </span>
          </div>
        ) }
        <ul className="box">
          <li>＊プロフィール写真の登録/表示には<strong className="text-red">性病検査</strong>もしくは<strong className="text-red">精液検査</strong>いずれかの登録が必要です。</li>
          <li>＊ご自身の容姿がわかる画像のみ登録可能です。</li>
          <li>【<strong className="text-blue">OK</strong>な例】証明写真、目や口元など一部のみのモザイク、幼少期の写真、全身画像、背後からの写真</li>
          <li>【<strong className="text-red">NG</strong>な例】人物が写っていない、複数の人物が写っている、全面モザイク、著作権などを侵害している画像、AIにより生成した画像、その他容姿の参考にならない画像</li>
        </ul>
      </div>
    </>
  );
};

export default Photos;
